'use client';

import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { useRouter, useSearchParams } from 'next/navigation';
import { useForm } from 'react-hook-form';
import { FaIcon } from '../../../../components/icon';
import styles from './FaqSearchForm.module.scss';
import raffleStyles from './FaqSearchForm.raffle.module.scss';

export interface FaqSearchFormProps {
  FormTextComponent: React.ComponentType<{
    name: string;
    // biome-ignore lint/suspicious/noExplicitAny: <explanation>
    control: any;
    placeholder: string;
    prefix?: React.ReactNode;
    outlined?: boolean;
    isSmall?: boolean;
  }>;
  variant?: 'default' | 'raffle';
}

function FaqSearchForm({ FormTextComponent, variant = 'default' }: FaqSearchFormProps) {
  const router = useRouter();
  const searchParams = useSearchParams();

  // variantに応じてスタイルを決定
  const currentStyles = variant === 'raffle' ? raffleStyles : styles;

  const { handleSubmit, getValues, control } = useForm({
    defaultValues: {
      q: searchParams?.get('q') || '',
    },
  });

  const submit = async () => {
    const q = getValues('q');
    if (q) {
      //@ts-ignore
      router.push(`/faq?q=${q}`);
    } else {
      //@ts-ignore
      router.push('/faq');
    }
  };

  return (
    <div>
      <form onSubmit={handleSubmit(submit)}>
        <FormTextComponent
          name='q'
          control={control}
          placeholder='質問を検索'
          prefix={
            <div className={currentStyles.searchIcon}>
              <FaIcon icon={faSearch} size='xl' />
            </div>
          }
          outlined
          isSmall={true}
        />
      </form>
    </div>
  );
}

export default FaqSearchForm;
